module.exports = __webpack_public_path__ + "media/images/pic/brodno/clancity-prepare-f9bb22febe86f5a66026efe2816ab979.png";